import { PropsWithChildren } from "react"

type Props = PropsWithChildren<{}>

export function SearchResultItem(props: Props) {
  return (
    <div data-search-item className="search-result-item scroll-my-[80px]">
      {props.children}
    </div>
  )
}
